import { Component, Input } from '@angular/core';
import { FormGenModel } from './../../../shared/models/form-gen.model';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { IDevice } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';

export const DEVICE_DATA_LIST: FormGenModel[] = [
  { label: 'SERIALNUMBER', value: 'serialNumber', autofocus: false, size: '6', required: false },
  { label: 'MANUFACTURER', value: 'manufacturer', autofocus: false, size: '4', required: true },
  { label: 'MODELL', value: 'modelNumber', autofocus: false, size: '4', required: true },
];

export const STATUS_LIST: FormGenModel[] = [
  { label: 'STATUS_AVAILABLE', value: 'active' },
  { label: 'STATUS_INACTIVE', value: 'inactive' }, { label: 'STATUS_ERROR', value: 'entered-in-error' },
  { label: 'STATUS_UNKNOWN', value: 'unknown' }
];

@Component({
  selector: 'inc-device-add',
  templateUrl: './device-add.component.html',
  styleUrls: ['./device-add.component.scss'],
})
export class DeviceAddComponent extends AbstractAddComponent<IDevice> {
  deviceDataList = DEVICE_DATA_LIST;
  statusList = STATUS_LIST;

  @Input() typeList: FormGenModel[];

  constructor() {
    super();
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      identifier: new FormArray([
        new FormGroup({
          value: new FormControl('', Validators.required)
        })
      ]),
      serialNumber: new FormControl(''),
      manufacturer: new FormControl('', Validators.required),
      modelNumber: new FormControl('', Validators.required),
      meta: new FormGroup({
        lastUpdated: new FormControl(new Date())
      }),
      type: new FormGroup({
        text: new FormControl('ACCESSORY', Validators.required),
        coding: new FormControl('')
      }),
      status: new FormControl('active', Validators.required),
      note: new FormArray([
        new FormGroup({
          authorReference: new FormGroup({
            reference: new FormControl(''),
            display: new FormControl('')
          }),
          text: new FormControl(''),
          time: new FormControl(new Date())
        })
      ]),
      patient: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      owner: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
    });
  }
}
